import { Button, CheckPicker } from 'rsuite';
import { searchCidadesFiltro, searchProdutosFiltro, searchRedesFiltro, searchUfsFiltro } from '../../filterServices';
import { useAsyncFilterOptions } from '../../hooks/useAsyncFilterOptions';
import { MonitoramentoTipo } from '../../types';
import styles from './FiltersBox.module.scss';

const TIPO_OPTIONS = [
  { label: 'Competitividade de Produto', value: MonitoramentoTipo.COMPETITIVIDADE_PRODUTO },
  { label: 'Competitividade de Varejo', value: MonitoramentoTipo.COMPETITIVIDADE_VAREJO },
];

export type FiltersBoxValue = {
  tipos?: MonitoramentoTipo[];
  produtoIds?: number[];
  redeIds?: number[];
  cidadeIds?: number[];
  ufs?: string[];
};

type FiltersBoxProps = {
  value: FiltersBoxValue;
  onChange: (value: FiltersBoxValue) => void;
};

export const FiltersBox = ({ value, onChange }: FiltersBoxProps) => {
  const produtoOptions = useAsyncFilterOptions('filtro-produtos', searchProdutosFiltro);
  const redeOptions = useAsyncFilterOptions('filtro-redes', searchRedesFiltro);
  const cidadeOptions = useAsyncFilterOptions('filtro-cidades', searchCidadesFiltro);
  const ufOptions = useAsyncFilterOptions('filtro-ufs', searchUfsFiltro);

  const handleChangeTipo = (nextValue: MonitoramentoTipo[]) => {
    onChange({ ...value, tipos: nextValue.length ? nextValue : undefined });
  };

  const handleChangeProduto = (nextValue: number[]) => {
    onChange({ ...value, produtoIds: nextValue.length ? nextValue : undefined });
  };

  const handleChangeRede = (nextValue: number[]) => {
    onChange({ ...value, redeIds: nextValue.length ? nextValue : undefined });
  };

  const handleChangeUf = (nextValue: string[]) => {
    onChange({ ...value, ufs: nextValue.length ? nextValue : undefined });
  };

  const handleChangeCidade = (nextValue: number[]) => {
    onChange({ ...value, cidadeIds: nextValue.length ? nextValue : undefined });
  };

  return (
    <div className={styles.container}>
      <div className={styles.filterBox}>
        <div className={styles.filtersRow}>
          <CheckPicker data={TIPO_OPTIONS} value={value.tipos ?? []} placeholder="Tipo de monitoramento" searchable={false} onChange={handleChangeTipo} />
          <CheckPicker
            data={produtoOptions.options}
            value={value.produtoIds ?? []}
            placeholder="Produtos"
            loading={produtoOptions.isLoading}
            onSearch={produtoOptions.onSearch}
            onChange={handleChangeProduto}
            locale={{ searchPlaceholder: 'Buscar produto', noResultsText: 'Digite para buscar' }}
          />
          <CheckPicker
            data={redeOptions.options}
            value={value.redeIds ?? []}
            placeholder="Redes"
            loading={redeOptions.isLoading}
            onSearch={redeOptions.onSearch}
            onChange={handleChangeRede}
            locale={{ searchPlaceholder: 'Buscar rede', noResultsText: 'Digite para buscar' }}
          />
          <CheckPicker
            data={ufOptions.options}
            value={value.ufs ?? []}
            placeholder="UF"
            loading={ufOptions.isLoading}
            onSearch={ufOptions.onSearch}
            onChange={handleChangeUf}
            locale={{ searchPlaceholder: 'Buscar UF', noResultsText: 'Digite para buscar' }}
          />
          <CheckPicker
            data={cidadeOptions.options}
            value={value.cidadeIds ?? []}
            placeholder="Cidade"
            loading={cidadeOptions.isLoading}
            onSearch={cidadeOptions.onSearch}
            onChange={handleChangeCidade}
            locale={{ searchPlaceholder: 'Buscar cidade', noResultsText: 'Digite para buscar' }}
          />
          {/* <CheckPicker
            data={cidadeOptions.options}
            value={value.cidadeIds ?? []}
            placeholder="Fabricante"
            loading={cidadeOptions.isLoading}
            onSearch={cidadeOptions.onSearch}
            onChange={handleChangeCidade}
            locale={{ searchPlaceholder: 'Buscar fabricante', noResultsText: 'Digite para buscar' }}
          />
          <CheckPicker
            data={cidadeOptions.options}
            value={value.cidadeIds ?? []}
            placeholder="Região"
            loading={cidadeOptions.isLoading}
            onSearch={cidadeOptions.onSearch}
            onChange={handleChangeCidade}
            locale={{ searchPlaceholder: 'Buscar região', noResultsText: 'Digite para buscar' }}
          />
          <CheckPicker
            data={cidadeOptions.options}
            value={value.cidadeIds ?? []}
            placeholder="Segmentos personalizados"
            loading={cidadeOptions.isLoading}
            onSearch={cidadeOptions.onSearch}
            onChange={handleChangeCidade}
            locale={{ searchPlaceholder: 'Buscar segmentos personalizados', noResultsText: 'Digite para buscar' }}
          />
          <CheckPicker
            data={cidadeOptions.options}
            value={value.cidadeIds ?? []}
            placeholder="Subsegmentos personalizados"
            loading={cidadeOptions.isLoading}
            onSearch={cidadeOptions.onSearch}
            onChange={handleChangeCidade}
            locale={{ searchPlaceholder: 'Buscar subsegmentos personalizados', noResultsText: 'Digite para buscar' }}
          /> */}
        </div>
        {/* <Button className={styles.clearFiltersButton}>Limpar filtros</Button> */}
      </div>
    </div>
  );
};
